// extracted by mini-css-extract-plugin
export var centerText = "_dg-8";
export var container = "_dg-0";
export var doughnutContainer = "_dg-7";
export var legend = "_dg-a";
export var legendItemColorDisplay = "_dg-b";
export var legendItemLabel = "_dg-d";
export var legendItemValue = "_dg-c";
export var lg = "_dg-5";
export var maxWidth = "_dg-9";
export var md = "_dg-4";
export var responsive = "_dg-6";
export var sm = "_dg-3";
export var xs = "_dg-2";
export var xxs = "_dg-1";